import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../constants/appInfo";

  import { useRouteMatch,Switch, Route } from "react-router-dom";
  import { useHistory,} from "react-router-dom";
import CreateBatchPopup from "./CreateBatchPopup";
import AdminBatchDashboardCard from "./AdminBatchDashboardCard";
import AdminBatchSections from "./AdminBatchSections";
import { Settings, Trash2 } from "lucide-react";
  
export default function AdminCourseBatchesCard({
    loadBatches,open,setOpen
  
}) {
    
      const {url}=useRouteMatch();
   const history = useHistory();
 
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibility, setVisibility] = useState('public');

       const AppToken = useSelector((state)=>state?.app?.app?.AppToken);

      const coursePostId = useSelector((state)=>state?.course?.course?.postId);
        const currentToken = useSelector((state)=>state?.user?.user?.token);
             const userEmail = useSelector((state)=>state?.user?.user?.user_email
            );
            
  useEffect(() => {
    if ( !coursePostId) return;
    loadBatches();

  }, [coursePostId,open]);

  async function loadBatches() {
    setLoading(true);
    try {

      const res = await axios.get(`${webUrlNode}/api/batches/?appToken=${AppToken}`, {
        params: {
         
          coursePostId,
          userEmail,
          currentToken,visibility:visibility
          
        }
      });
    //  console.log(res.data.items)
      setItems(res.data.items || []);

    } finally {
      setLoading(false);
    }
  }

  async function deleteBatch(batchId) {

    // const ok = window.confirm("Delete this batch?");

    // if (!ok) return;

    try {

      await axios.delete(`${webUrlNode}/api/batches/${batchId}?appToken=${AppToken}`, {
        
        params: {
          userEmail,coursePostId,
          currentToken }
      });

      setItems(prev => prev.filter(b => b.batchId !== batchId));

    } catch (e) {
      alert("Failed to delete batch");
    }
  }

  return (
    <div style={{ padding: 12 }}>

      <div style={{ marginBottom: 12 }}>
        
        <div style={{ fontSize: 18, color: "#666" }}>
        showing  {items?.length} {items?.length>1?"batches":"batch"} in a course 
        </div></div>
      {loading && (
        <div style={{ fontSize: 13 }}>Loading...</div>
      )}

      {!loading && items.length === 0 && (
        <div style={{ fontSize: 13, color: "#888" }}>
          No batches created yet
        </div>
      )}

      {items.map((b,i) => (
        <BatchAdminRow
          key={b.batchId}
          index={i}

          batch={b}
          onEdit={() => {
             history.push(`${url}/dash/${b.batchId}`);
          }}
          onDelete={() => deleteBatch(b.batchId)}
        />
      ))}

    </div>
  );
}


/* ------------------------------------------------ */

function BatchAdminRow({ batch,index, onEdit, onDelete }) {

  return (<div>
    <div
      style={{ background:"#f9f9f9",
        
        borderRadius: 6,
        padding: "15px 18px",
        marginBottom: 10,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",flexWrap:"wrap"
      }}
    >
      <div style={{ flex: 1 }}>

        <div style={{ fontWeight: 600 ,fontSize:"20px"}}>
        Batch {index+1} : {batch.batchName}
        </div>

        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
          {batch.mode} • {batch.enrollmentStatus}
        </div>

        {(batch.startDate || batch.endDate) && (
          <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
            {batch.startDate
              ? new Date(batch.startDate).toLocaleDateString()
              : "—"}
            {" – "}
            {batch.endDate
              ? new Date(batch.endDate).toLocaleDateString()
              : "—"}
          </div>
        )}

        {typeof batch.price === "number" && (
          <div style={{ fontSize: 12, marginTop: 4 }}>
            Price: ₹{batch.price}
          </div>
        )}

      </div>

      <div style={{borderRadius:"15px",marginTop:"13px",marginRight:"3px",padding:"10px",gap:"5px"
    ,display:"flex",justifyContent:"space-between"}}>
        <button style={{width:"90px",position:"relative",fontSize:"14px",background:"#ffffff",color:"#222",
        padding:"5px 10px" ,borderRadius:"5px",cursor:"pointer",zIndex:"9",border:"2px solid rgba(144, 202, 249,1)",display:"flex",justifyContent:"space-between",gap:"5px",alignItems:"center"}} 
         onClick={onEdit}>
        <Settings size={16} color="#222222"/>  <span>Manage</span>
        </button>
        <button style={{width:"90px",position:"relative",fontSize:"14px",border:"2px solid rgb(249, 201, 199)",background:"#fff",color:"#222222",
        padding:"5px 10px" ,borderRadius:"5px",cursor:"pointer",zIndex:"9",display:"flex",justifyContent:"space-between",gap:"5px",alignItems:"center"}} 
       
          onClick={onDelete}
         
        ><Trash2 size={16} color="#222222"/> 
         <span>Delete</span> 
        </button>
      </div>
    </div>
    </div>
  );
}
